export default __webpack_public_path__ + "static/media/src1.5570d917.mp3";